export class BasketCounter {
    static update(hasAdd) {
        const counterList = document.querySelectorAll('.js-basket-counter');

        if (counterList) {

            counterList.forEach(counter => {

                let count = parseInt(counter.textContent ?? 0);

                if (hasAdd) {
                    count++;
                } else {
                    count--;
                }

                counter.textContent = count;


                if (count <= 0) {
                    counter.classList.remove('is-active')
                } else {
                    counter.classList.add('is-active')
                }
            });
        }
    }
}